<template>
  <div class="router-links">
    <router-link
      v-if="!special"
      target="_blank"
      :to="{
        name: 'position-languages',
        query: { position_id, company_id, position_status }
      }"
      class="button is-hovered is-outlined"
      ><p>Languages</p></router-link
    >
    <router-link
      target="_blank"
      :to="{
        name: 'position-skills',
        query: { position_id, company_id, position_status }
      }"
      class="button is-hovered is-outlined"
      ><p>Skills</p></router-link
    >
    <router-link
      target="_blank"
      :to="{
        name: 'position-educations',
        query: { position_id, company_id, position_status }
      }"
      class="button is-hovered is-outlined"
      ><p>Educations</p></router-link
    >
    <router-link
      target="_blank"
      :to="{
        name: 'position-texts',
        query: { position_id, company_id, position_status }
      }"
      class="button is-hovered is-outlined"
      ><p>Texts</p></router-link
    >
    <router-link
      target="_blank"
      :to="{
        name: 'position-locations',
        query: { position_id, company_id, position_status }
      }"
      class="button is-hovered is-outlined"
      ><p>Locations</p></router-link
    >
    <router-link
      target="_blank"
      :to="{ name: 'position-questions', query: { position_id, company_id, position_status } }"
      class="button is-hovered is-outlined"
      ><p>Questions</p></router-link
    >
    <router-link
      v-if="!special"
      target="_blank"
      :to="{
        name: 'position-offers',
        query: {
          position_id,
          company_id,
          position_status,
          statuses: 'awaiting_company,system_strong',
          sort: '-sent_at'
        }
      }"
      class="button is-hovered is-outlined"
      ><p>Offers</p></router-link
    >
  </div>
</template>
<script>
export default {
  name: 'position-form-links',
  props: ['position_id', 'company_id', 'position_status', 'special']
}
</script>
